import React, { memo } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { checkExpried } from '../../utils/helpers';
import CustomLink from '../common/CustomLink';

const BannerActiveskin = memo((props) => {
  const {
    background_colour,
    banner_activeskin,
    theme,
    heading,
    sub_heading,
    start_date,
    end_date,
    logo,
    link_url,
    display_activeskin,
    display,
    banner,
  } = props;

  if (checkExpried(start_date, end_date)) return null;

  return (
    <div id="banner-activeskin" className="container-xl main__banner">
      {display_activeskin && banner_activeskin && banner_activeskin?.gatsbyImageData ? (
        <CustomLink link={link_url}>
          <div
            className={`banner banner-activekin`}
            style={{ backgroundColor: background_colour || 'blue' }}
          >
            <div className="banner__item">
              <div className="banner__image">
                {banner_activeskin?.gatsbyImageData && (
                  <GatsbyImage
                    image={banner_activeskin?.gatsbyImageData}
                    loading="eager"
                    alt={banner_activeskin?.alt || 'activeskin'}
                  />
                )}
              </div>

              <div className={`banner__content ${theme}`}>
                <div className={`banner__inner`}>
                  {logo?.gatsbyImageData && (
                    <div className="banner__logo">
                      <GatsbyImage
                        image={logo?.gatsbyImageData}
                        loading="eager"
                        alt={logo?.alt || 'activeskin'}
                      />
                    </div>
                  )}
                  <div className="banner__text">
                    {heading && <h3 className="banner__text--headline">{heading}</h3>}
                    {sub_heading && <p className="banner__text--subheading">{sub_heading}</p>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CustomLink>
      ) : display && banner?.gatsbyImageData ? (
        <figure className="banner-activekin-image">
          <CustomLink link={link_url}>
            {banner?.gatsbyImageData && (
              <GatsbyImage
                className="image__pc"
                image={banner?.gatsbyImageData}
                loading="eager"
                alt={banner?.alt || 'activeskin'}
              />
            )}

            {banner?.thumbnails?.mobile?.gatsbyImageData && (
              <GatsbyImage
                className="image__mobile"
                loading="eager"
                image={banner?.thumbnails?.mobile?.gatsbyImageData}
                alt={banner?.thumbnails?.mobile?.alt || 'activeskin'}
              />
            )}
          </CustomLink>
        </figure>
      ) : null}
    </div>
  );
});

export default BannerActiveskin;
